export default __webpack_public_path__ + "static/media/projects_icon.4d258c8b.svg";